@if (loading) {
  @if (!progressIsSet) {
    <button mat-button [ngClass]="type" disabled="true">
      <mat-icon>
        <mat-spinner [color]="color" [diameter]="diameter"
        style="margin-left: 2px;margin-top: 2px"></mat-spinner>
      </mat-icon>
    </button>
  } @else {
    <button mat-button [ngClass]="type" disabled="true">
      <!--            <div style="position:absolute;text-align: center;right: 50%;top:50%;transform: translate(50%,-50%);font-size: xx-small;font-weight: bold">-->
    <!--            </div>-->
    <div style="font-size: x-small;font-weight: bold;margin-top: -2px;" class="color-primary">
      {{progress}} %
    </div>
    <mat-progress-bar [color]="color" mode="indeterminate"
      style="margin-top: -7px;margin-bottom: 5px;">
    </mat-progress-bar>
  </button>
}
} @else {
  <ng-content>
  </ng-content>
}
